import { render, staticRenderFns } from "./TaskSummaryBox.vue?vue&type=template&id=04482027&scoped=true&"
import script from "./TaskSummaryBox.vue?vue&type=script&lang=js&"
export * from "./TaskSummaryBox.vue?vue&type=script&lang=js&"
import style0 from "./TaskSummaryBox.vue?vue&type=style&index=0&id=04482027&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04482027",
  null
  
)

export default component.exports